import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetContactData, GetContactDataParams, GetContactDataResponse} from 'domain/usecases';

export class RemoteGetContactData implements GetContactData {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetContactDataResponse>,
	) {}

	async get({signal, ...params}: GetContactDataParams): Promise<GetContactDataResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
